/*
 * @Author: lidan
 * @Date: 2020-11-02 10:56:30
 * @LastEditTime: 2021-03-31 19:32:21
 * @LastEditors: lidan
 * @Description: 距离管理api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\distance.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_E6YUN_BASE_WEB = "",
  E6_MS_TMS_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//********************* 距离管理 ****************** */

// 获取距离管理列表数据
export function findPageDistance(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/distance/findPage`,
    method: "post",
    data
  });
}

// 距离管理新增
export function saveDistance(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/distance/save`,
    method: "post",
    data
  });
}

// 根据ID查询距离
export function getByIdDistance(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/distance/getById`,
    method: "get",
    params
  });
}

// 距离管理修改
export function updateDistance(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/distance/update`,
    method: "post",
    data
  });
}

// 距离管理删除
export function deleteDistance(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/distance/delete`,
    method: "post",
    data
  });
}

// 距离管理导出
export function exportDistance(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/distance/export`,
    method: "post",
    data
  });
}

// 距离管理导入
export function importDistance(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/distance/import`,
    method: "post",
    data
  });
}

// 距离管理历史记录
export function historyDistance(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/distance/findDistanceHistoryByPage`,
    method: "post",
    data
  });
}

// 区域下拉框
export function getAreaLablePositionDistance(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: "post",
    data
  });
}
